import { useLocation } from 'react-router-dom';
import Avatar from '../ui/Avatar';
import useAuthStore from '../../stores/authStore';

const LABELS = {
  '/': '⊞ Dashboard',
  '/contacts': '◉ Kunden',
  '/analyses': '⟳ Analysen',
  '/reports': '▤ Reports & PDF',
  '/share-links': '⬡ Share-Links',
  '/knowledge': '◎ Knowledge Base',
  '/analytics': '◈ Analytics',
  '/users': '◉ Benutzer & Tokens',
  '/seo': '◎ SEO Rankings',
  '/settings': '⚙ Einstellungen',
};

export default function Topbar() {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);

  const path = location.pathname;
  const label = LABELS[path] || (path.startsWith('/contacts/') ? '◉ Kunden-Detail' : '');

  return (
    <div className="bg-white border-b border-gray-200 px-7 py-[13px] flex items-center justify-between shrink-0">
      <div className="flex items-center gap-2.5">
        <div className="w-[7px] h-[7px] rounded-full bg-green" />
        <span className="text-[12.5px] text-gray-500">System aktiv</span>
        <span className="text-gray-200 mx-1">·</span>
        <span className="text-[12.5px] text-gray-500">{label}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-[11.5px] text-gray-400">v3.0.0</span>
        <div className="w-px h-4 bg-gray-200" />
        <Avatar name={user?.name || 'U'} size={24} />
        <span className="text-[12.5px] font-medium">{user?.name || ''}</span>
      </div>
    </div>
  );
}
